
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Bookinnovacrystaforoutstaion() {



    const cardData =
    {
        keyword: ' Book Innova Crysta for Outstation',
        heading: 'Prince Cabs: Book Innova Crysta for Outstation',
        headingDescription: 'Prince Cabs makes it easy to Book Innova Crysta for Outstation, perfect for family tours, group travel, corporate trips, and long-distance journeys. Our premium Innova Crysta vehicles are spacious, well-maintained, and equipped with modern amenities to ensure a safe and luxurious ride. With professional chauffeurs, transparent per km pricing, and flexible travel plans, we provide a hassle-free outstation travel experience. Enjoy comfort, reliability, and affordability with Prince Cabs’ trusted Innova Crysta booking service for outstation trips.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was once the seat of the powerful Peshwas of the Maratha Empire. Though much of it was destroyed by fire in 1828, its grand gates, massive walls, and sprawling gardens still stand tall. The evening light-and-sound show brings alive tales of Maratha bravery. Visitors enjoy exploring its ruins and imagining its glorious past. It is a must-visit landmark for history lovers in Pune. Shaniwar Wada is the perfect blend of legend and architecture."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, is an architectural marvel with deep historical importance. During the Quit India Movement, Mahatma Gandhi, Kasturba Gandhi, and Sarojini Naidu were imprisoned here. The palace now houses a museum with artifacts, photos, and personal belongings of Gandhi. Its sprawling gardens provide a peaceful retreat for visitors. It is a national monument of pride and sacrifice. The palace stands as a timeless reminder of India’s freedom struggle."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, about 30 km from Pune, is a historic hill fortress famous for the 1670 Battle of Sinhagad. The fort’s ruins, bastions, and watchtowers tell stories of Maratha valor. Trekkers enjoy scenic routes, especially during monsoon when the hills turn lush green. From the summit, panoramic views of the Sahyadris are breathtaking. Local vendors sell traditional pithla-bhakri, adding to the fort experience. It is a favorite among history enthusiasts and nature lovers."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous religious landmark, dedicated to Lord Ganesha. The idol is adorned with gold and jewels, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple is decorated with grandeur and cultural programs. It is also involved in various charitable activities. The temple’s central location makes it easily accessible. It is both a spiritual and cultural icon of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill, one of Pune’s highest points, offers panoramic views of the entire city. At its summit lies the Parvati Temple complex, dedicated to Lord Shiva and Goddess Parvati. The climb of more than 100 steps is rewarding with peace and spirituality at the top. The Peshwa Museum nearby adds historical depth. Sunrises and sunsets from the hill are especially captivating. It is a serene escape from the city’s hustle."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. It features massive pillars, a stone-carved Nandi, and an unfinished mandapa. Despite being in the city center, it offers a peaceful environment. The temple is a fine example of Rashtrakuta-era architecture. Visitors often come here for meditation and photography. It remains a hidden gem in Pune’s heritage map."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove of over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include musical instruments, sculptures, everyday objects, and the recreated Mastani Mahal. The museum reflects the cultural richness of Maharashtra and India. It fascinates both art lovers and historians alike. Its three-storey building itself is a heritage attraction. It is one of Pune’s most unique museums."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "Osho International Meditation Resort in Koregaon Park is a world-renowned spiritual retreat. Visitors from across the globe come here for meditation, wellness therapies, and yoga. Surrounded by serene gardens and modern architecture, it offers a peaceful escape. The ashram promotes holistic well-being and personal growth. Its vibrant international community adds cosmopolitan charm. It is a unique blend of spirituality and modern lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity, located in Viman Nagar, is Pune’s largest lifestyle and shopping mall. It houses hundreds of international and Indian brands, offering a world-class retail experience. Entertainment includes multiplex cinemas, gaming zones, and live events. The mall also features a wide range of restaurants and cafés. Seasonal festivals like Diwali and Christmas add vibrancy. It is the ultimate hub for shopping, dining, and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located about 20 km from Pune, is a scenic spot surrounded by hills. The reservoir supplies water to the city and offers natural beauty. Families enjoy picnics, boating, and street food near the dam. Monsoon enhances its charm with mist and greenery. Evenings here are especially peaceful with cool breezes. It is a refreshing escape for city dwellers."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by Mulshi Dam, is a serene outstation spot near Pune. It is surrounded by Sahyadri hills, forests, and waterfalls. Visitors enjoy camping, nature walks, and photography here. During monsoon, the lake looks spectacular with overflowing water and lush valleys. Eco-resorts nearby offer a comfortable stay amidst nature. It is ideal for couples, families, and adventure seekers."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Located on Senapati Bapat Road, Chaturshringi Temple is one of Pune’s oldest and most revered shrines. Dedicated to Goddess Chaturshringi (Durga), it requires devotees to climb over 100 steps to reach the sanctum. The temple is especially grand during Navratri with vibrant celebrations. It attracts devotees from all over Maharashtra. The views from the hilltop add to its charm. It is both a spiritual and cultural landmark."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "This war memorial is dedicated to Indian soldiers who sacrificed their lives post-independence. It displays tanks, weapons, and war memorabilia. The museum inside narrates stories of India’s military history. Visitors attend the evening flag retreat ceremony, which is deeply moving. It is both educational and inspiring for families and students. The memorial instills pride and patriotism."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread across 39 acres, is a lush botanical park in Pune. Managed by the Agri-Horticultural Society, it houses exotic trees, flower nurseries, and shaded walking paths. Families come here for picnics and relaxation. The annual flower show is a highlight for nature lovers. It is one of Pune’s oldest gardens with colonial-era history. A green oasis in the bustling city, it offers peace and tranquility."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, Pune’s highest hill, is a popular trekking and jogging destination. The hilltop offers panoramic views of the entire city. It is rich in biodiversity, with birds, trees, and fresh air. Fitness enthusiasts flock here for morning walks and cycling. Sunrises and sunsets from Vetal Hill are breathtaking. It is Pune’s natural lung and a much-needed retreat for nature lovers."
  }
],


"services": [
    {
        "name": "Pune to Mumbai Airport Drop Innova",
        "description": "Reliable and comfortable Innova taxi service for airport drop from Pune to Mumbai. Enjoy a hassle-free ride with professional drivers, spacious seating, and timely pickups to ensure you reach Mumbai airport on schedule with all your luggage safely handled."
    },
    {
        "name": "Pune Mumbai Innova Rental",
        "description": "Rent an Innova for your Pune to Mumbai trip with flexible rental options, perfect for families, business travelers, and groups. Our Innova rentals offer premium comfort, ample space, and experienced chauffeurs for a smooth journey between the two cities."
    },
    {
        "name": "Pune to Mumbai Airport Innova",
        "description": "Book Innova cab service from Pune to Mumbai Airport with guaranteed punctuality and clean vehicles. Perfect for solo travelers, families, or corporate clients needing a comfortable ride to the airport with all necessary amenities included."
    },
    {
        "name": "Pune to Mumbai Innova",
        "description": "Safe and reliable Innova cab service for direct travel from Pune to Mumbai. Our service guarantees well-maintained vehicles, professional drivers, and affordable rates, making your intercity travel comfortable and stress-free."
    },
    {
        "name": "Pune Mumbai Innova",
        "description": "Efficient Innova rental service for travel between Pune and Mumbai. Whether it’s for corporate trips, family outings, or weekend getaways, our Innova cabs provide a perfect blend of comfort, safety, and affordability."
    },
    {
        "name": "Pune to Mumbai Innova Cab",
        "description": "Book an Innova cab from Pune to Mumbai for a spacious, air-conditioned, and smooth ride. Our drivers are courteous and knowledgeable of the best routes to avoid traffic, ensuring timely arrivals for all your appointments or leisure plans."
    },
    {
        "name": "Pune to Mumbai Round Trip Innova Cab",
        "description": "Convenient round-trip Innova cab service between Pune and Mumbai, perfect for business trips, family visits, and tours. Enjoy the comfort of the same vehicle and driver for your return journey, with flexible scheduling and competitive pricing."
    },
    {
        "name": "Pune to Mumbai Innova Crysta Taxi",
        "description": "Travel in style and comfort with our Innova Crysta taxi service from Pune to Mumbai. Featuring premium interiors and added amenities, this service is ideal for those who value luxury alongside reliable transportation."
    },
    {
        "name": "Pune to Mumbai Dzire vs Innova Cab",
        "description": "Compare Dzire and Innova cabs for Pune to Mumbai travel. Choose Innova for more space and comfort, ideal for family or group travel, or Dzire for economical and efficient rides. Our fleet offers both options with professional drivers and transparent pricing."
    },
    {
        "name": "Pune to Mumbai Family Innova",
        "description": "Family-friendly Innova cab service from Pune to Mumbai designed to accommodate all your travel needs including child safety seats, spacious interiors, and a comfortable environment for a relaxed journey with your loved ones."
    },
    {
        "name": "Affordable Innova Pune to Mumbai",
        "description": "Affordable Innova cab services for Pune to Mumbai travelers who want quality and comfort without breaking the bank. Transparent pricing, no hidden charges, and reliable vehicles ensure you get the best value for your money."
    },
    {
        "name": "Pune to Mumbai Innova Cab Service",
        "description": "Top-rated Innova cab service for seamless travel from Pune to Mumbai. With on-time pickups, courteous drivers, and well-maintained vehicles, we ensure a safe and pleasant ride every time."
    },
    {
        "name": "Innova Crysta Pune to Mumbai Tour",
        "description": "Exclusive Innova Crysta tour packages from Pune to Mumbai tailored for business trips, leisure tours, and family outings. Experience luxury, comfort, and professional service while exploring the best of both cities."
    }
],
"tableData": [
    ["Pune to Mumbai Airport Drop Innova", "Pune Mumbai Innova Rental"],
    ["Pune to Mumbai Airport Innova", "Pune to Mumbai Innova"],
    ["Pune Mumbai Innova", "Pune to Mumbai Innova Cab"],
    ["Pune to Mumbai Round Trip Innova Cab", "Pune to Mumbai Innova Crysta Taxi"],
    ["Pune to Mumbai Dzire vs Innova Cab", "Pune to Mumbai Family Innova"],
    ["Affordable Innova Pune to Mumbai", "Pune to Mumbai Innova Cab Service"],
    ["Innova Crysta Pune to Mumbai Tour", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Book Premium Innova Crysta for Comfortable Outstation Travel",
        "WhyChoosedescription": "Prince Cabs provides top-quality Innova Crysta cabs for outstation journeys, perfect for families, corporate groups, and travelers seeking a spacious and luxurious ride. Enjoy plush seating, ample legroom, and modern amenities that make long-distance travel relaxing and enjoyable."
    },
    {
        "WhyChooseheading": "Well-Maintained & Sanitized Innova Crysta Fleet",
        "WhyChoosedescription": "Our fleet of Innova Crysta vehicles is regularly serviced and thoroughly sanitized before and after every trip to ensure your safety and comfort. Equipped with air conditioning, GPS, and safety features, each cab promises a premium and secure travel experience on your outstation route."
    },
    {
        "WhyChooseheading": "Experienced Drivers Skilled in Outstation Routes",
        "WhyChoosedescription": "All our Innova Crysta bookings include professional drivers who are experienced in handling long-distance travel. They know the best routes, traffic conditions, and safety protocols to provide timely and smooth journeys to your destination."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Itinerary",
        "WhyChoosedescription": "Whether you need a one-way trip, round trip, or multi-day package, Prince Cabs offers customizable Innova Crysta outstation bookings. Book easily online, via WhatsApp, or by phone with instant confirmation and transparent pricing tailored to your travel plans."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our per kilometer rates and fixed packages are clearly communicated before booking, including driver allowance, tolls, and taxes. You get a detailed fare estimate upfront, ensuring no surprises at the end of your outstation journey."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Experience",
        "WhyChoosedescription": "Our customer care team is available around the clock to assist with your Innova Crysta outstation bookings, answer queries, and support you throughout the journey, guaranteeing a smooth and worry-free experience."
    }
]



























    }

const faqData = [
    {
        question: 'Can I book an Innova Crysta for outstation travel with Prince Cabs?',
        answer: 'Yes, Prince Cabs offers premium Innova Crysta bookings for outstation trips from Pune. It’s a top choice for families, corporate groups, and long-distance travelers.',
    },
    {
        question: 'Why choose Innova Crysta for outstation journeys?',
        answer: 'Innova Crysta offers spacious seating, superior suspension, captain seats, AC vents for all rows, and ample luggage space—ideal for comfort during long trips.',
    },
    {
        question: 'What is the per km rate for Innova Crysta for outstation?',
        answer: 'The per km rate for Innova Crysta starts from ₹20/km. Pricing may vary based on destination, duration, and additional requirements like driver allowance and tolls.',
    },
    {
        question: 'Is there a minimum km requirement for outstation bookings?',
        answer: 'Yes, outstation bookings are typically calculated on a minimum of 250 km per day basis, even if you travel less than that distance.',
    },
    {
        question: 'Can I book an Innova Crysta for a multi-day outstation trip?',
        answer: 'Absolutely! Prince Cabs specializes in multi-day outstation cab bookings. You can customize your route, stops, and return plans with ease.',
    },
    {
        question: 'Are Prince Cabs’ Innova Crysta vehicles maintained and sanitized?',
        answer: 'Yes, all our Innova Crysta cabs are thoroughly cleaned, sanitized, and serviced before every trip to ensure your safety and comfort.',
    },
    {
        question: 'How do I book an Innova Crysta for outstation travel?',
        answer: 'Booking is easy—visit our website or call our helpline. Provide your travel dates, destination, and passenger count, and we’ll confirm your Innova Crysta in minutes.',
    },
];

const testimonials = [
    {
        name: "Mr. Devendra Jain",
        position: "Corporate Traveler",
        text: "I booked an Innova Crysta for a Pune to Aurangabad trip. The ride was extremely comfortable, driver was polite, and everything went smoothly.",
        image: "/img/testimonial/testimonial-thumb-outstation-1.png",
    },
    {
        name: "Ms. Sneha Rao",
        position: "Family Trip Planner",
        text: "Prince Cabs gave us a clean Innova Crysta for our outstation tour to Konkan. Great service, punctual pickup, and well-maintained vehicle. Highly recommend!",
        image: "/img/testimonial/testimonial-thumb-outstation-2.png",
    },
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Book Innova Crysta for Outstation",
  "image": "https://princecab.com/assets/images/innova-crysta-outstation.jpg",
  "description": "Book Innova Crysta for outstation trips with Prince Cabs. Enjoy spacious, comfortable, and luxury rides with affordable rental rates, perfect for long-distance travel.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.75",
    "ratingCount": "7300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "0",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/book-innova-crysta-outstation"
  }
};





    return (
        <div>
<Helmet>
  <title>Book Innova Crysta for Outstation | Luxury Outstation Cab Service | Prince Cabs</title>
  <meta
    name="description"
    content="Book Innova Crysta for outstation trips with Prince Cabs. Comfortable, spacious, and affordable Innova rental for long-distance travel and tours."
  />
  <meta
    name="keywords"
    content="Innova Crysta Taxi Booking, Innova Crysta Pune to Goa, Innova Crysta Cab Fares, Innova per km Price, Innova Crysta Rental Near Me, Innova 8 Seater on Rent, Innova Crysta Hire, Innova Car Rent per Day, Innova Crysta on Rent, Innova Crysta Rent per Day, Innova Crysta for Outstation Trip, Toyota Innova Outstation Hire, Affordable Innova Crysta Outstation, Luxury Innova Crysta Booking"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/31.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bookinnovacrystaforoutstaion;